import { render } from "./yes-no-input.component.vue?vue&type=template&id=ec0d8ac2&scoped=true&ts=true"
import script from "./yes-no-input.component.vue?vue&type=script&lang=ts"
export * from "./yes-no-input.component.vue?vue&type=script&lang=ts"

import "./yes-no-input.component.vue?vue&type=style&index=0&id=ec0d8ac2&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0d8ac2"]])

export default __exports__